/* widerruf-webpanda.js – WebPanda Fix (inkl. Präfix B-) */
(function () {
  function byId(id){ return document.getElementById(id); }
  function val(id){ var el = byId(id); return el ? (el.value || '').trim() : ''; }

  function buildSummary(){
    var first = val('WiderrufVorname');
    var last  = val('WiderrufNachname');
    var full  = (first + ' ' + last).trim();

    // 1. NEU: Die getippte Nummer holen und "B-" davorsetzen (wenn etwas eingetippt wurde)
    var bestellSichtbar = val('WiderrufBestellnrSichtbar');
    var bestellKomplett = bestellSichtbar ? 'B-' + bestellSichtbar : '';

    var header =
      'WIDERRUF ZUSAMMENFASSUNG\n' +
      'Name: ' + full + '\n' +
      'E-Mail: ' + val('WiderrufEmail') + '\n' +
      'Telefon: ' + val('WiderrufTelefon') + '\n' +
      'Bestellnummer: ' + bestellKomplett + '\n' + // 2. NEU: Hier die zusammengesetzte Nummer einfügen
      'Bestellt am: ' + val('WiderrufBestelldatum') + '\n' +
      'Erhalten am: ' + val('WiderrufErhalten') + '\n' +
      'Grund: ' + val('WiderrufGrund') + '\n' +
      'Artikel:\n' + val('WiderrufArtikel') + '\n' +
      'Adresse:\n' + val('WiderrufAdresse') + '\n\n' +
      '— Zusätzliche Nachricht des Kunden —\n' +
      (val('WiderrufKundenNachricht') || '-') + '\n\n' +
      'Erklärung: Hiermit widerrufe ich den oben genannten Vertrag.';

    return { full: full, body: header, bestellKomplett: bestellKomplett };
  }

  function apply(){
    var data = buildSummary();
    var nameHidden = byId('WiderrufFullName');
    if (nameHidden) nameHidden.value = data.full;

    var bodyHidden = byId('WiderrufBodyHidden');
    if (bodyHidden) bodyHidden.value = data.body;

    // 3. NEU: Das versteckte Shopify-Feld (falls einzeln gesendet) ebenfalls füllen
    var bestellHidden = byId('WiderrufBestellnrVersteckt');
    if (bestellHidden) bestellHidden.value = data.bestellKomplett;
  }

  document.addEventListener('DOMContentLoaded', function(){
    var root = document.querySelector('[data-widerruf]');
    if (!root) return;
    var form = root.querySelector('form');
    if (!form) return;

    // 4. NEU: 'WiderrufBestellnr' in 'WiderrufBestellnrSichtbar' geändert
    var ids = [
      'WiderrufVorname','WiderrufNachname','WiderrufEmail','WiderrufTelefon','WiderrufAdresse',
      'WiderrufBestellnrSichtbar','WiderrufBestelldatum','WiderrufErhalten','WiderrufGrund','WiderrufArtikel','WiderrufKundenNachricht'
    ];

    ids.forEach(function(id){
      var el = byId(id);
      if (!el) return;
      el.addEventListener('input', apply);
      el.addEventListener('change', apply);
    });

    apply();

    form.addEventListener('submit', function(){
      apply();
    }, true);
  });
})();